export function debouncePromise(caller, delay) {
    let timeout = null;
    return new Promise((res, rej) => {
        if (timeout) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(() => caller().then((x) => res(x)).catch((err) => rej(err)), delay);
    });
}
